<template>
  <div class="tui-conversation" @click="handleClickConv">
    <!-- <ConversationHeader v-if="isShowConversationHeader" ref="headerRef" /> -->
    <ConversationNetwork />
    <ConversationList
      @handleSwitchConversation="handleSwitchConversation"
      @saveAllConversationList="saveAllConversationList"
    />
  </div>
</template>
<script lang="ts" setup>
import { TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { ref } from '../../adapter-vue';
import ConversationList from './conversation-list/index.vue';
import ConversationHeader from './conversation-header/index.vue';
import ConversationNetwork from './conversation-network/index.vue';

const emits = defineEmits([
  'handleSwitchConversation',
  'saveAtConversationList',
  'clearChatInput',
  'saveAllConversationList',
]);

const totalUnreadCount = ref(0);
const headerRef = ref<typeof ConversationHeader>();
const isShowConversationHeader = ref<boolean>(true);
const LAST_CONVERSATION_ID_KEY = 'gx_chat_conversation_id';
TUIStore.watch(StoreName.CONV, {
  totalUnreadCount: (count: number) => {
    totalUnreadCount.value = count;
  },
});

TUIStore.watch(StoreName.CUSTOM, {
  isShowConversationHeader: (showStatus: boolean) => {
    isShowConversationHeader.value = showStatus !== false;
  },
});
const saveAllConversationList = (conversationList: any) => {
  emits('saveAllConversationList', conversationList);
};
const handleSwitchConversation = (
  conversationID: string,
  conversationList: any
) => {
  sessionStorage.setItem(LAST_CONVERSATION_ID_KEY, conversationID);
  emits('clearChatInput');
  emits('saveAtConversationList', conversationList);
  emits('handleSwitchConversation', conversationID);
};

const handleClickConv = () => {
  headerRef?.value?.closeChildren();
};
</script>

<style lang="scss" scoped src="./style/index.scss"></style>
